import { render, staticRenderFns } from "./CesShopGoodsList.vue?vue&type=template&id=163ef474&scoped=true"
import script from "./CesShopGoodsList.vue?vue&type=script&lang=js"
export * from "./CesShopGoodsList.vue?vue&type=script&lang=js"
import style0 from "./CesShopGoodsList.vue?vue&type=style&index=0&id=163ef474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163ef474",
  null
  
)

export default component.exports